<template>
  <v-card class="card--shadow">
    <v-card-title class="purple accent-4">
      <div class="subtitle-1 white--text">Counseling Activity Form</div>
    </v-card-title>
    <v-card-text class="pt-4">
      <form-require-noti />
      <v-row>
        <v-col lg="2">
          <label>Code</label>
          <v-text-field
            v-model="counselingData.mdrtb_code"
            hide-details
            type="text"
            outlined
            dense
          ></v-text-field>
        </v-col>
        <v-col lg="2">
          <label>Year</label>
          <v-text-field
            v-model="counselingData.mdrtb_year"
            hide-details
            type="text"
            outlined
            dense
          ></v-text-field>
        </v-col>
        <v-col lg="4">
          <label>Date <require-sign /></label>
          <date-picker
            @clearDate="counselingData.date = null"
            :validationMsg="handleFieldErrors($v.counselingData.date)"
            :date="counselingData.date"
            v-model="counselingData.date"
            :min="minDate"
            :max="maxDate"
          />
        </v-col>
        <v-col md="4">
          <label>Phone <require-sign /></label>
          <v-text-field
            v-model.trim="counselingData.phone"
            :error-messages="handleFieldErrors($v.counselingData.phone)"
            type="text"
            outlined
            dense
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col lg="8">
          <label>Topics <require-sign /></label>
          <v-select
            :items="topicsOpt"
            multiple
            v-model="counselingData.topics"
            :error-messages="handleFieldErrors($v.counselingData.topics)"
            item-text="text"
            item-value="topic_id"
            dense
            outlined
          ></v-select>
        </v-col>
      </v-row>
      <p class="subtitle-1">
        Number of household members
        <span class="red--text subtitle-2">
          ( You must fill in one field at below)</span
        >
      </p>
      <v-row>
        <v-col md="4">
          <label>less than 5 <require-sign /></label>
          <v-text-field
            v-model.trim="counselingData.less_than_5_count"
            :error-messages="
              handleFieldErrors($v.counselingData.less_than_5_count)
            "
            type="number"
            outlined
            dense
          ></v-text-field>
        </v-col>
        <v-col md="4">
          <label>Between 5 and 14 <require-sign /></label>
          <v-text-field
            v-model.trim="counselingData.between_5_and_14_count"
            :error-messages="
              handleFieldErrors($v.counselingData.between_5_and_14_count)
            "
            type="number"
            outlined
            dense
          ></v-text-field>
        </v-col>
        <v-col md="4">
          <label>greater than 15 <require-sign /></label>
          <v-text-field
            v-model.trim="counselingData.greate_than_15"
            :error-messages="
              handleFieldErrors($v.counselingData.greate_than_15)
            "
            type="number"
            outlined
            dense
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row class="pl-4">
        <template v-if="counselingData.checked === 1">
          <p class="pr-3 pt-1 font-weight-bold green--text">Checked: Yes</p>
          <v-btn small @click="checkedActivity(0)" outlined color="indigo">
            Unchecked
          </v-btn>
        </template>
        <template v-else>
          <p class="pr-3 pt-1 font-weight-bold warning--text">Checked: No</p>
          <v-btn small @click="checkedActivity(1)" outlined color="indigo">
            Checked
          </v-btn>
        </template>
      </v-row>
    </v-card-text>

    <v-card-actions class="px-4 pb-4">
      <v-spacer></v-spacer>
    </v-card-actions>
  </v-card>
</template>

<script>
import { required, helpers } from "vuelidate/lib/validators";
import { ValidationMixin } from "../../mixins/ValidationMixin";
import { limitDateMixin } from "../../mixins/limitDateMixin";
import { mapState } from "vuex";
import FormRequireNoti from "@/components/notification/FormRequireNoti.vue";
import RequireSign from "@/components/notification/RequireSign.vue";
import DatePicker from "@/components/common/DatePicker.vue";

export default {
  components: { RequireSign, FormRequireNoti, DatePicker },
  mixins: [ValidationMixin, limitDateMixin],
  props: {
    counselingData: {
      type: Object,
      default: () => {
        return {
          date: null,
          phone: null,
          mdrtb_code: null,
          mdrtb_year: null,
          less_than_5_count: null,
          between_5_and_14_count: null,
          greate_than_15: null,
          topics: [],
        };
      },
    },
  },
  data: () => ({
    topicsOpt: [
      { topic_id: "1", text: "Treatment Adherence" },
      { topic_id: "2", text: "Psychological Support" },
      { topic_id: "3", text: "Contact Investigation" },
      { topic_id: "4", text: "Infection Control" },
      { topic_id: "5", text: "Checking Side Effect" },
      { topic_id: "6", text: "Service Directory" },
    ],
  }),
  validations() {
    return {
      counselingData: {
        date: { required },
        patient_id: { required },
        phone: { required },
        topics: { required },
        less_than_5_count: {
          required: this.checkHouseMemberValidation,
        },
        greate_than_15: {
          required: this.checkHouseMemberValidation,
        },
        between_5_and_14_count: {
          required: this.checkHouseMemberValidation,
        },
      },
    };
  },
  computed: {
    ...mapState("Loading", ["loading"]),
    ...mapState("Patient", ["patients"]),

    // topicsHandler: {
    //   get() {
    //     if (this.counselingData.topics) {
    //       const matchTopic = this.counselingData.topics.map((topic) => {
    //         const findTopic = this.topicsOpt.find((item) => {
    //           return topic.topic_id == item.id;
    //         });
    //         topic.id = findTopic.id;
    //         topic.text = findTopic.text;
    //         return topic;
    //       });
    //       return matchTopic;
    //     } else return this.counselingData.topics;
    //   },
    //   set(newValue) {
    //     if (this.counselingData.topics) this.counselingData.topics = [];
    //     this.counselingData.topics = newValue;
    //   },
    // },
  },
  methods: {
    checkedActivity(checkedValue) {
      this.$store.dispatch("Counseling/checked", {
        id: this.counselingData.id,
        checked: checkedValue,
      });
    },
    checkHouseMemberValidation(value) {
      if (
        this.counselingData.greate_than_15 == null &&
        this.counselingData.between_5_and_14_count == null &&
        this.counselingData.less_than_5_count == null
      )
        return false;
      //? vuelidate helpers object make false to all propertries
      //? that include in current object (eg - less_than_5_count)
      return !helpers.req(value) || true;
    },
  },
  created() {
    this.$store.dispatch("Patient/getPatients");
  },
  beforeMount() {
    this.counselingData.date = !this.counselingData.date
      ? this.minDate
      : this.counselingData.date;
  },
};
</script>

<style scoped></style>
